import { render, staticRenderFns } from "./Shangwenjian.vue?vue&type=template&id=12565f1e&scoped=true&"
import script from "./Shangwenjian.vue?vue&type=script&lang=js&"
export * from "./Shangwenjian.vue?vue&type=script&lang=js&"
import style0 from "./Shangwenjian.vue?vue&type=style&index=0&id=12565f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12565f1e",
  null
  
)

export default component.exports